import page from './page';
import user from './user';
import competition from './competition';
import event from './event';
import article from './article';
import athlete from './athlete';
import discipline from './discipline';
import document from './document';
import email from './email';
import book from './book';

export default {
  ...page,
  ...user,
  ...competition,
  ...event,
  ...article,
  ...athlete,
  ...discipline,
  ...document,
  ...email,
  ...book,
};
